import {
  IRequirementResponse,
  RequirementExpirationStatus
} from "@wingspanhq/payments/dist/interfaces";

export const selectorExpiringRequirements = (
  requirements: IRequirementResponse[]
) =>
  requirements.filter(
    e => e.expirationStatus === RequirementExpirationStatus.Expiring
  );
